import fetch from 'isomorphic-fetch';
import memoizeOne from 'memoize-one';
import React from 'react';
import { connect } from 'react-redux';
import { hasApplicationUpdate } from '~/ApplicationUpdate';
import { ApplicationState } from '~/Store';
import { Link } from '~/UI/Button';

import { cancelFlashMessagesDismiss, removeFlashMessage, scheduleFlashMessagesDismiss } from './actions';
import FlashMessages from './FlashMessages';
import { Message } from './reducer';

async function fetchWebIndex() {
	const params = { headers: { 'If-Modified-Since': '', 'If-None-Match': '' } };
	await Promise.all([fetch(window.location.href, params), fetch('/', params)]);
	window.location.replace(window.location.href);
}

const ApplicationUpdateMessage = {
	key: -1,
	type: 'update',
	text: (
		<span>
			{'New version of application is available, please '}
			<Link onClick={fetchWebIndex}>update now</Link>.
		</span>
	),
	timeout: null,
	dismissable: false,
};

const appendApplicationUpdateMessage = memoizeOne((messages, applicationUpdate) => {
	return hasApplicationUpdate(applicationUpdate) ? [...messages, ApplicationUpdateMessage] : messages;
});

function mapStateToProps(state: ApplicationState): {
	messages: Message[];
} {
	return {
		messages: appendApplicationUpdateMessage(state.flashMessages.messages, state.applicationUpdate),
	};
}

const actions = {
	onDismiss: removeFlashMessage,
	onMouseEnter: cancelFlashMessagesDismiss,
	onMouseLeave: scheduleFlashMessagesDismiss,
};

export default connect(mapStateToProps, actions)(FlashMessages);
